import { createSlice } from "@reduxjs/toolkit";

// Global state for the "all unresolved conflicts" list modal (see
// components/TemplatePageComponents/GlobalTemplateConflictsListModal.jsx), opened from the
// "Resolve now" button on GlobalTemplateConflictBanner.jsx. Lives in Redux - rendered once
// from ContentLayout, like the banner itself - so it's available on whichever screen the
// banner was clicked from, not just the Templates page.
const templateConflictsListModalSlice = createSlice({
  name: "templateConflictsListModal",
  initialState: {
    isOpen: false,
  },
  reducers: {
    openTemplateConflictsListModal: state => {
      state.isOpen = true;
    },
    closeTemplateConflictsListModal: state => {
      state.isOpen = false;
    },
  },
});

export const { openTemplateConflictsListModal, closeTemplateConflictsListModal } =
  templateConflictsListModalSlice.actions;
export default templateConflictsListModalSlice.reducer;
